<template>
  <div class="question">
    <common-head title="智能问答" />
    <beautiful-chat
       class="message-box"
      :participants="participants"
      :on-message-was-sent="onMessageWasSent"
      :message-list="messageList"
      :new-messages-count="newMessagesCount"
      :is-open="true"
      :close="closeChat"
      :open="openChat"
      :show-emoji="false"
      :show-file="false"
      :show-edition="true"
      :show-deletion="true"
      :show-typing-indicator="showTypingIndicator"
      :show-launcher="true"
      placeholder="请输入问题"
      :show-close-button="true"
      :colors="colors"
      :always-scroll-to-bottom="true"
      :disable-user-list-toggle="false"
      :message-styling="false"
      :show-header="false"
      :suggestions="['常见问题','新冠','流感']"
      @onType="handleOnType"
      @edit="editMessage"
    >
      <template v-slot:text-message-body="{ message }">
        <div v-if="message.type === 'text'">
          <p class="message-text">
            {{ message.data.text }}
          </p>
        </div>
        <div v-else-if="message.type === 'auto'"></div>
        <div class="message-date">
          {{ message.data.meta }}
        </div>
      </template>
    </beautiful-chat>
    <div class="fill-iphone-safe-area"></div>
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import { postCustomerHistory, postCustomerConsult, postCustomerResolve, postCustomerManual, addConsultHistory } from 'api/customer'
import { participants, colors } from './config'

export default {
  components: {
    CommonHead
  },
  provide() {
    return {
      questionClick: (value) => {
        // 加入消息列表
        const message = {
          type: 'text',
          author: 'me',
          data: { text: String(value.title), meta: `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}` }
        }
        this.messageList.push(message)

        const messageRsp = {
          type: 'answer',
          author: 'system',
          data: { text: String(value.answer), meta: `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}` }
        }
        this.messageList.push(messageRsp)
        addConsultHistory({ questionText: String(value.title), rspText: String(value.answer) })
      },
      serviceClick: () => {
        postCustomerManual({}, { hideLoading: true }).then(({ code, data }) => {
          if (code === 0) {
            this.messageList.push({
              type: 'system',
              data: { text: data }
            })
          }
        })
      },
      solveClick: () => {
        postCustomerResolve({}, { hideLoading: true }).then(({ code }) => {
          if (code === 0) {
            this.messageList.push({
              type: 'system',
              author: `me`,
              data: { text: '咨询结束' }
            })
          }
        })
      }
    }
  },
  data() {
    return {
      // 正在聊天的用户
      participants,
      // 消息列表
      messageList: [],
      // 新消息的数量
      newMessagesCount: 0,
      // 正在输入的提示状态
      showTypingIndicator: '',
      colors,
    }
  },
  created() {
    this.postCustomerHistory()
  },
  methods: {
    // 发送问题
    async postCustomerConsult() {
      const { code, data } = await postCustomerConsult({}, { hideLoading: true })
      if (code === 0) {
        this.swipeList = data
      }
    },
    filterData(item) {
      if (!item?.type) {
        return item
      }
      if (item.type === 'question') {
        this.messageList.push({
          type: 'quesition',
          author: `user1`,
          id: 0,
          data: {
            questionTitle: item.title,
            questions: item.questions,
            meta: item.dateTime
          }
        })
        return
      }
      if (item.type === 'text') {
        this.messageList.push({
          author: `me`,
          type: 'text',
          data: {
            text: item.title,
            meta: item.dateTime
          }
        })
        return
      }
      if (item.type === 'povRsp') {
        this.messageList.push({
          author: `user1`,
          type: 'answer',
          data: {
            text: item.rspText,
            meta: item.dateTime
          }
        })
        return
      }
      return item
    },
    // 通知栏
    async postCustomerHistory() {
      const { code, data } = await postCustomerHistory({}, { hideLoading: true })
      if (code === 0) {
        data.forEach((item) => {
          this.filterData(item)
        })
      }
    },
    async onMessageWasSent(message) {
      const date = `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
      message.data.meta = date
      this.messageList = [...this.messageList, message]
      const { code, data } = await postCustomerConsult(
        { msg: message.data.text },
        { hideLoading: true }
      )
      if (code === 0 && data) {
        const res = this.filterData(data)
        if (res) {
          this.messageList.push(res)
        }
      }
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    handleOnType() {
      console.log('Emit typing event')
    },
    editMessage(message) {
      const m = this.messageList.find((m) => m.id === message.id)
      m.isEdited = true
      m.data.text = message.data.text
    }
  }
}
</script>

<style lang="less" scoped>
@import url(../../style/question.less);
</style>